module.exports = __webpack_public_path__ + "img/earth.d09c0b44.svg";